<template>
    <div>
        <div v-if="imageObject !== null">
            <div>
                <img :src="imageObject.path" style="width: 100%" :alt="$lang('Zdjęcie') + ' ' + imageObject.name">
            </div>
            <div class="mt-2">
                <div>
                    <a class="mr-3" href="#" data-toggle="modal" :data-target="'#'+component_name+'_delete_modal'"
                    >{{ delete_image_label || $lang('Usuń obraz') }}</a>
                </div>
            </div>
        </div>
        <div v-else>
            <input style="display: none" type="file" :id="component_name+'_file'" :ref="component_name+'_file'" :accept="'image/*'" v-on:change="addImage"/>
            <button type="button" class="btn btn-primary ml-auto mr-3"
                    @click="getFile">{{ add_image_label || $lang('Dodaj obraz')}}
            </button>
        </div>

        <div class="modal fade" :id="component_name+'_delete_modal'" :ref="component_name+'_delete_modal'" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Usunięcie obrazu') }}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ $lang('Czy na pewno chcesz usunąć obraz?') }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="closeModal">
                            {{ $lang('Nie') }}
                        </button>
                        <button class="btn btn-primary" @click="deleteImage">
                            {{ $lang('Tak') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropzone from "./dropzone";
import AttachmentTable from "./task/attachment-table";
import ShowNotification from "../mixins/show-notification";
import {EventBus} from "../mixins/event-bus";

export default {
    name: "add-image-component",
    components: {Dropzone, AttachmentTable},
    mixins: [ShowNotification],
    props: {
        image: {type: Array|Object|null, required: true},
        route_delete_image: {type: String, required: true},
        route_add_image: {type: String, required: true},
        add_image_label: {type: String, required: false, default: ''},
        delete_image_label: {type: String, required: false, default: ''},
        component_name: {type: String, required: false, default: 'add_image_component'},
        in_modal: {type: Boolean, required: false, default: false},
    },
    data() {
        return {
            fileObject: null,
            imageObject: this.image,
        }
    },
    methods: {
        deleteImage() {
            this.closeModal();
            const self = this;
            let data = self.imageObject;
            axios.delete(this.route_delete_image, {data})
                .then(function (response) {
                    if (response.data) {
                        self.imageObject = null;
                        self.emitDeleteImageSuccess();
                    }
                })
                .catch(function (error) {
                    self.showNotification('error', 'Nie udało się usunąć obrazu!');
                });
        },
        addImage() {
            this.fileObject = this.$refs[this.component_name + '_file'].files[0];
            let formData = new FormData();
            formData.append('image', this.fileObject);
            let self = this;
            axios.post(this.route_add_image, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .catch(function (error) {
                    self.showNotification('error', 'Dodanie obrazu nie powiodło się!')
                })
                .then(function (response) {
                    self.imageObject = response.data;
                    self.emitUploadImageSuccess();
                    self.showNotification('success', 'Dodano obraz do bazy!');
                });
        },
        getFile() {
            document.getElementById(this.component_name+'_file').click();
        },
        closeModal() {
            let element = this.$refs[this.component_name+'_delete_modal'];
            $(element).modal('toggle');
        },
        emitUploadImageSuccess() {
            EventBus.$emit(this.component_name+'_upload_image_success', {image: this.imageObject});
        },
        emitDeleteImageSuccess() {
            EventBus.$emit(this.component_name+'_delete_image_success');
        }
    },
    mounted() {
        if (this.in_modal) {
            $(this.$refs[this.component_name+'_delete_modal']).on("hidden.bs.modal", function () {
                $('body').addClass('modal-open');
            });
        }
    },
    beforeDestroy() {
        if (this.in_modal) {
            $(this.$refs[this.component_name+'_delete_modal']).off("hidden.bs.modal", function () {
                $('body').addClass('modal-open');
            });
        }
    },
    watch: {
        image: {
            handler() {
                this.imageObject = this.image;
            }
        }
    }
}
</script>
